import axios from 'axios';
import CTFCard from 'components/CTFCard';
import { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Divider from '@mui/material/Divider';
import PageHeader from 'components/PageHeader';
import Loading from 'components/Loading';

// function CryptoHackRank(setter: any) {
//     axios
//         .get('https://cryptohack.org/api/user/R4GN4R/')
//         .then((res) => {
//             setter(res.data.rank);
//         })
//         .catch((err) => {
//             console.log(err);
//             setter('error');
//         });
// }

// to get the rank from Cryptohack
// {
//     name: 'CryptoHack',
//     profileLink: 'https://cryptohack.org/user/R4GN4R/',
//     image: require('images/CTFs/cryptohack.jpg'),
//     color: '238, 77, 46',
//     profile_rank(setter: any) {
//         CryptoHackRank(setter);
//     },
// },

export default function CaptureTheFlags() {
    const [ctfsNumber, setCtfNumber] = useState(10);
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://api.myjson.online/v1/records/a2a87d9f-21a8-44a2-a14d-bd0259240dce',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'm-collection-access-token':
                                '14fd5407-a000-42bb-92d8-a885c8f90f8b',
                        },
                    }
                );
                const json = await response.json();
                setData(json.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    return (
        <Container className='p-3'>
            <PageHeader
                Title='Capture The Flag'
                Description='CTF (aka Capture The Flag) is a competition where teams or individuals have to solve a number of challenges. The one that solves/collects most flags the fastest wins the competition. Once each challenge has been solved successfully, the user will find a "flag" within the challenge that is proof of completion.'
            />
            <Loading show={!data}>
                {data && (
                    <>
                        <Row className='mb-4'>
                            {data.ctfs
                                .slice(0, ctfsNumber)
                                .map((current_ctf: any) => {
                                    return (
                                        <CTFCard
                                            key={current_ctf.name}
                                            Name={current_ctf.name}
                                            Image={current_ctf.image}
                                            ColorRGB={current_ctf.color}
                                            ProfileLink={
                                                current_ctf.profileLink
                                            }
                                            ProfileRank={
                                                current_ctf.profile_rank
                                            }
                                        />
                                    );
                                })}
                        </Row>
                        <Divider
                            style={{ background: '#e8e8e8' }}
                            variant='middle'
                        />
                        <Row className='justify-content-center p-3'>
                            <h4
                                className='text custom-button'
                                style={{
                                    width: 'fit-content',
                                    textAlign: 'center',
                                }}
                                onClick={() => {
                                    if (ctfsNumber < data.ctfs.length) {
                                        setCtfNumber(ctfsNumber + 10);
                                    } else {
                                        setCtfNumber(10);
                                    }
                                }}
                            >
                                {data.ctfs.length > ctfsNumber
                                    ? 'Show more...'
                                    : 'Show less...'}
                            </h4>
                        </Row>
                    </>
                )}
            </Loading>
        </Container>
    );
}
